import { render, staticRenderFns } from "./SubdivisionForm.vue?vue&type=template&id=3926ffa3"
import script from "./SubdivisionForm.vue?vue&type=script&lang=js"
export * from "./SubdivisionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports